import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import Footer from "../footer/Footer";
import { fetchContentBlockById } from "../../services/topicContentService";
import { ContentBlock } from "../study/topic-content/TopicContentRenderer";

const ContentBlockDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backUrl = location.state?.backUrl;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetchContentBlockById(id);
      if (res.status === 200) setData(res.data);
      else setError(true);
      setLoading(false);
    };
    load();
  }, [id]);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#f7f9fb" }}>
      <Navbar />
      <div style={{ flex: 1, maxWidth: 900, width: "100%", margin: "0 auto", padding: "32px 20px 64px", boxSizing: "border-box" }}>
        <button
          onClick={() => navigate(backUrl || -1)}
          style={{ background: "none", border: "none", color: "#019095", fontWeight: 700, fontSize: 14, cursor: "pointer", padding: "6px 0", marginBottom: 24 }}
        >
          ← Back
        </button>

        {loading && <p style={{ color: "#9ca3af" }}>Loading…</p>}
        {error && <p style={{ color: "#b91c1c" }}>Content block not found.</p>}
        {data && (
          <>
            <h1 style={{ fontSize: "1.6rem", fontWeight: 800, color: "#1a202c", marginBottom: "1.25rem" }}>{data.title}</h1>
            <ContentBlock data={data} />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ContentBlockDetailPage;
